import Immutable from 'immutable';

import { createModuleState } from 'ps-gui';

import DashboardModel from './dashboardmodel';
import UsageReportModel from './usagereportmodel';
import MyRecordingsModel from './myrecordingsmodel';
import SystemSettingsModel from './systemsettingsmodel';
import SessionLogModel from './sessionlogmodel';
import NotificationAdminModel from './notificationadminmodel';
import UserProfileModel from './userprofile/userprofilemodel';
import SystemMaintenanceModel from './systemmaintenancemodel';
import UserAdminModel from './useradminmodel';
import AuthenticationCodeModel from './authenticationcode/authenticationcodemodel';
import SubmissionModel from './submissionmodel';
import SubmissionAdminModel from './submissionadminmodel';
import BankIdModel from './bankidmodel';
import AffirmationSubmissionSettingsModel from './affsubsettings/affirmationsubmissionsettingsmodel';
import AffirmationSubmissionModel from './affsub/affirmationsubmissionmodel';
import AffirmationSubmissionAdminModel from './affsub/affirmationsubmissionadminmodel';
import AffirmationDistributionResultModel from './affirmationdistributionresultmodel';
import RecordingProtocolAdminModel from './recordingprotocol/recordingprotocoladminmodel';
import DocumentModel from './documentmodel';
// import CatalogRecordingModel from './catalogrecordingmodel';


const moduleList = Immutable.List([
	new DashboardModel(),
	new UsageReportModel(),
	new MyRecordingsModel(),
	// new CatalogRecordingModel(),
	//	new NotificationModel(),
	new SystemSettingsModel(),
	new SessionLogModel(),
	new NotificationAdminModel(),
	new SystemMaintenanceModel(),
	new UserProfileModel(),
	new UserAdminModel(),
	new AuthenticationCodeModel(),
	new SubmissionModel(),
	new AffirmationSubmissionAdminModel(),
	new SubmissionAdminModel(),
	new BankIdModel(),
	new AffirmationSubmissionModel(),
	new AffirmationSubmissionSettingsModel(),
	new AffirmationDistributionResultModel(),
	new RecordingProtocolAdminModel(),
	new DocumentModel(),
]);

const EMPTY_MAP = Immutable.Map({});
const EMPTY_STATE = createModuleState('MainPage');

export default class MainPageModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}

	#setProperty(name, value) {
		return new MainPageModel(this.#data.set(name, value));
	}

	initialize(globalContext) {
		return new MainPageModel(getInitialData(globalContext).set('initialized', true));
	}

	setSelectedModuleId(moduleId) {
		return this.#setProperty('selectedModuleId', moduleId);
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}
}

const HIDE_MY_RECORDINGS_IF_EMPTY = false;

function getInitialData(globalContext) {
	const admin = globalContext.isAdmin();
	const submissionAdmin = globalContext.isSubmissionAdmin();
	const hasRecordings = globalContext.hasRecordings();
	let blackList = {};
	if (!hasRecordings && HIDE_MY_RECORDINGS_IF_EMPTY) {
		blackList['MyRecordings'] = true;
	}
	if (!globalContext.hasMovieProducer()) {
		blackList['AffirmationSubmission'] = true;
		blackList['AffirmationDistributionResult'] = true;
	}
	if (!globalContext.hasPermanentCatalog()) {
		blackList['CatalogRecording'] = true;
	}
	console.log('preparing initial data for MainPageModel', admin);
	let data = EMPTY_MAP;
	const menuItems = moduleList.map(model => model.getState().get('__module')).filter(moduleId => !blackList[moduleId]);

	data = data.set('leftMenuItems', menuItems.filter(moduleId => isLeftMenuItem(moduleId) && isAdminModule(moduleId) === admin && isSubmissionAdminModule(moduleId) === submissionAdmin));
	data = data.set('rightMenuItems', menuItems.filter(moduleId => isRightMenuItem(moduleId) && isAdminModule(moduleId) === admin && isSubmissionAdminModule(moduleId) === submissionAdmin));
	data = data.set('selectedModuleId', data.getIn(['leftMenuItems', 0]));
	moduleList.forEach(model => {
		data = data.setIn(['module', model.getState().get('__module')], model.getState());
	});

	return data;
}

function isItemlessModule(moduleId) {
	return moduleId === 'UserProfile';
}

function isAdminModule(moduleId) {
	// return moduleId === 'AffirmationSubmissionSettings';
	return (
		moduleId === 'SystemSettings' || moduleId === 'NotificationAdmin' || moduleId === 'SessionLog' ||
		moduleId === 'SystemMaintenance' || moduleId === 'UserAdmin' || moduleId === 'AuthenticationCode' ||
		moduleId === 'BankId' || moduleId === 'AffirmationSubmissionSettings'
	);
}

function isSubmissionAdminModule(moduleId) {
	return moduleId === 'SubmissionAdmin' || moduleId === 'AffirmationSubmissionAdmin' || moduleId === 'RecordingProtocolAdmin';
}

function isRightMenuItem(moduleId) {
	return moduleId === 'Notifications';
}

function isLeftMenuItem(moduleId) {
	return !isRightMenuItem(moduleId) && !isItemlessModule(moduleId);
}
